import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/bhojanshala/categories";

export const Route = createFileRoute("/admin/_bhojanshala/bhojan-categories")({
  component: Page,
});
